import { COLORS, FONTS } from '../../constants';

const styles = theme => {
  const minMd = theme.breakpoints.up('md');

  return {
    modalPaper: {
      marginLeft: 0,
      marginRight: 0,
    },
    root: {
      width: '100%',
      position: 'relative',
      fontFamily: FONTS.PRIMARY,
    },
    inner: {
      [minMd]: {
        display: 'flex',
      },
    },
    leftPanel: {
      display: 'none',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      [minMd]: {
        display: 'block',
        width: '50%',
        paddingTop: 80,
      },
    },
    rightPanel: {
      width: '100%',
      [minMd]: {
        width: '50%',
      },
    },
    rightPanelContent: {
      padding: '30px 20px 20px 20px',
      [minMd]: {
        padding: '50px 30px 20px 30px',
      },
    },
    topCloseButton: {
      zIndex: 999,
      position: 'absolute',
      right: 5,
      top: 14,
      color: COLORS.WHITE,
      [minMd]: {
        top: 10,
        right: 30,
        color: COLORS.GREEN,
      },
    },
    formTopContentContainer: {
      lineHeight: 1.4,
      marginBottom: 20,
      color: COLORS.GREY_DARK,
      [minMd]: {
        marginTop: 20,
      },
    },
    headingText: {
      fontSize: '1rem',
      fontWeight: 600,
      marginTop: 0,
      marginBottom: 10,
      [minMd]: {
        fontSize: '1.4rem',
      },
    },
    normalText: {
      fontSize: '0.875rem',
      [minMd]: {
        fontSize: '1rem',
      },
    },
    toolBar: {
      backgroundColor: COLORS.GREEN,
      padding: '15px 15px 15px 20px',
      borderBottom: `2px solid ${COLORS.GREEN_LIGHT}`,
      [minMd]: {
        display: 'none',
      },
    },
  };
};

export default styles;
